module.exports = __webpack_public_path__ + "static/pic12-98f60fb5f1d2458b54b23af68bdd46a2.jpeg";